import {all, put, race, select, take, takeEvery} from "redux-saga/effects";
import forkWithErrHandler from "../../shared/utils/forkWithErrHandler";
import {ActionType, getType} from "typesafe-actions";
import {closeTutorial, showTutorial} from "./actions";
import {IApplicationState} from "../index";
import {actuallyShowDialog, closeDialog, showDialog} from "../dialog-manager/actions";
import {AnyAction} from "redux";
import {loadScene} from "../routing/actions";

function* showTutorialWorker() {
    yield takeEvery(getType(showTutorial.request), function* ({ payload: options }: ActionType<typeof showTutorial.request>) {
        const {tutorials} = yield select(({ tutorial }: IApplicationState) => ({
            tutorials: tutorial.tutorials
        }));

        if (tutorials[options.title]) {
            yield put(showTutorial.failure(options.title));
            return;
        }

        yield put(showDialog({
            type: "Tutorial",
            options: {
                ...options,
                delay: options.delay || 0
            }
        }));

        yield take((action: AnyAction) => {
            return action.type === getType(actuallyShowDialog)
                && action.payload.type === 'Tutorial';
        });

        yield put(showTutorial.success(options.title));

        const {success} = yield race({
            success: take(getType(closeDialog)),
            failure: take(getType(loadScene.request))
        });

        if (!success) {
            yield put(closeDialog());
        }

        yield put(closeTutorial(options.title));
    })
}

export default function* tutorialSaga() {
    yield all([
        forkWithErrHandler("tutorialSaga", "showTutorialWorker", showTutorialWorker)
    ]);
}